exports = module.exports = require("../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".van-image-preview{top:0;left:0;width:100%;height:100%;position:fixed}.van-image-preview__image{top:0;left:0;right:0;bottom:0;margin:auto;max-width:100%;max-height:100%;position:absolute}.van-image-preview__index{position:absolute;top:10px;left:50%;color:#fff;font-size:14px;letter-spacing:2px;-webkit-transform:translate(-50%);transform:translate(-50%)}.van-image-preview__overlay{background-color:rgba(0,0,0,.9)}.van-image-preview .van-swipe{height:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vant/es/image-preview/index.css
// module id = 560
// module chunks = 0